import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_EarlyTermination = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_EarlyTermination' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Therapist:</span>
                            <input type='text' id="txtTherapist" name="txtTherapist" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Termination/Ineligibility:</span>
                            <input type='date' id="txtTerminationDate" name="txtTerminationDate" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>The above referenced client was terminated early from treatment for the following reason(s):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_1' name='chkTerminationReason_1' className='add-only' value="At the court/probation officer's request" /> At the court/probation officer's request
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_2' name='chkTerminationReason_2' className='add-only' value="Client does not meet IFI admission criteria" /> Client does not meet IFI admission criteria
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_3' name='chkTerminationReason_3' className='add-only' value="Client is leaving the area" /> Client is leaving the area
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_4' name='chkTerminationReason_4' className='add-only' value="Has missed excessive appointments" /> Has missed excessive appointments
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_5' name='chkTerminationReason_5' className='add-only' value="Lack of non-participation by parent" /> Lack of non-participation by parent
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_6' name='chkTerminationReason_6' className='add-only' value="Long term incarceration" /> Long term incarceration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_7' name='chkTerminationReason_7' className='add-only' value="No longer making appointments" /> No longer making appointments
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_8' name='chkTerminationReason_8' className='add-only' value="Parent refused services (case not opened)" /> Parent refused services (case not opened)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_9' name='chkTerminationReason_9' className='add-only' value="Referred for other services" /> Referred for other services
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_10' name='chkTerminationReason_10' className='add-only' value="Resistance to treatment plan" /> Resistance to treatment plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_11' name='chkTerminationReason_11' className='add-only' value="Therapist is leaving" /> Therapist is leaving
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='chkTerminationReason_12' name='chkTerminationReason_12' className='add-only' value="Other" /> Other
                        </td>
                    </tr>
                </table>
                <p  >
                    <span className='eleHeader'>Recommendations:</span>
                    <span className='small'>Therapist is to make treatment recommendations
                        based on dynamics of client.</span>
                    <textarea id="txtRecommendations" name="txtRecommendations" className='add-only' ></textarea></p>
                <p  >
                    <span className='eleHeader'>Client is being referred to the following agency for alternative services:</span>
                    <span className='small'>Provide whatever community linkage was recommended.</span>
                    <textarea id="txtAgencyReferral" name="txtAgencyReferral" className='add-only' ></textarea></p>
                <p  >
                    <span className='eleHeader'>Narrative of progress or lack of and impact of early termination:</span>
                    <span className='small'>Provide detailed description of progress of lack thereof.</span>
                    <textarea id="txtProgress" name="txtProgress" className='add-only' ></textarea></p>


            </div>
        </form >
    )
}